export const isReversalEntry = item => Boolean(item?.is_reversal)

export const isReversedRecord = item => Boolean(item?.is_reversed)

export const getActiveRecords = items => (items || []).filter(item => !isReversedRecord(item) && !isReversalEntry(item))

export const getReversedRecords = items => (items || []).filter(item => isReversedRecord(item) && !isReversalEntry(item))

export const getReversalEntries = items => (items || []).filter(item => isReversalEntry(item))

export const sumAmounts = (items, amountKey = "amount") =>
  (items || []).reduce((sum, item) => sum + Number(item?.[amountKey] || 0), 0)

export const getGrossAmount = (items, amountKey = "amount") => sumAmounts(getActiveRecords(items).concat(getReversedRecords(items)), amountKey)

export const getNetAmount = (items, amountKey = "amount") => sumAmounts(getActiveRecords(items), amountKey)

export const getReversedAmount = (items, amountKey = "amount") => sumAmounts(getReversedRecords(items), amountKey)

export const getReversalEntryAmount = (items, amountKey = "amount") => sumAmounts(getReversalEntries(items), amountKey)

export const getActiveCount = items => getActiveRecords(items).length

export const getReversedCount = items => getReversedRecords(items).length

export const getRecordStatus = item => {
  if (isReversalEntry(item)) return "reversal_entry"
  if (isReversedRecord(item)) return "reversed"
  return "active"
}
